<template>
    <div>
        <div v-if="! allCareerPosts" class="loader-wrapper">
            <!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#000">
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                </path>
                </g>
            </g>
            </svg>
        </div>

       <div v-else>
         <div v-if="allCareerPosts.length > 0">

          <div class="bordered-content-row">
             <div class="row">
               <div class="col-lg-3 col-md-12">
                 <h2 class="title navy-text">Current Openings</h2>
               </div>

              <div class="col-lg-9">
                <div class="map-filter-container">
                  <div class="filter-row" :class="{ active: activeFilters['categories'].length }">
                    <span class="filter-label">Category<span class="reset-filters" @click="resetFilter('categories');">&times;</span></span>
                    <ul class="filter-list" v-if="categoryFilters">
                      <li
                      v-for="(value, key) in categoryFilters"
                      :key="key"
                      @click="toggleFilter('categories', value)"
                      :class="{ active: activeFilters['categories'].includes(value), disabled: disabledFilters['categories'].includes(value) }"
                      >
                          {{value}}
                      </li>
                    </ul>
                  </div>
                  <div class="filter-row" :class="{ active: activeFilters['locations'].length }">
                    <span class="filter-label">Locations<span class="reset-filters" @click="resetFilter('locations')">&times;</span></span>
                    <ul class="filter-list" v-if="locationFilters">
                      <li
                      v-for="(value, key) in locationFilters"
                      :key="key"
                      @click="toggleFilter('locations', value)"
                      :class="{ active: activeFilters['locations'].includes(value), disabled: disabledFilters['locations'].includes(value) }"
                      >
                          {{value}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div v-for="category in categoryFilters" :key="category" v-if="getPostsByCategory(category).length > 0">
              <div class="bordered-content-row">
                <div class="row">
                  <div class="col-lg-3 col-md-12">
                    <h2 class="title navy-text">{{ category }}</h2>
                  </div>

                  <div class="col-lg-9">
                    <CareerItem v-for="careerPost in getPostsByCategory(category)" :career-post="careerPost" :key="careerPost.ID" v-if="activeFilters['locations'].includes(careerPost.career_location) || activeFilters['locations'].length == 0"></CareerItem>
                  </div>
                </div>
              </div>
            </div>

         </div>

         <div v-else>
           <div class="empty-state">
             <h2 class="heading navy-text">There are currently no career posts available.</h2>
           </div>
         </div>

       </div>
    </div>
</template>

<script>
import CareerItem from "./career-item"

export default {
  name: "category-listing",
  data() {
    return {
        locationFilters: null,
        categoryFilters: null,
        allCareerPosts: null,
        filteredCareerPosts: null,
        activeFilters: {
            categories: [],
            locations: []
        },
        disabledFilters: {
            categories: [],
            locations: []
        }
    }
  },
  components: {
      CareerItem
  },
  watch: {
        allCareerPosts() {
            this.setCateogryFilters();
            this.setLocationFilters();
        }
  },
  mounted() {
      var request = new XMLHttpRequest()
        request.open(
        "GET",
        "/wp-json/wp/v2/careers/?status=publish&per_page=100",
        true
        )
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                let responseBody = JSON.parse(request.responseText)

                this.allCareerPosts = _.map(responseBody, careerPost => {
                let customFields = careerPost.acf
                careerPost = _.merge(careerPost, careerPost.acf)
                return careerPost
                })

                // Initial hotel load: show all then apply URL
                this.filteredCareerPosts = this.allCareerPosts

                this.applyURLFilters()
            } else {
                console.error("OnLoad: Could not fetch hotel data!")
            }
        }
        request.onerror = () =>
        console.error("OnError: Could not fetch hotel data!")
        request.send()
  },
  methods: {
    getPostsByCategory(category) {
        return _.filter(this.filteredCareerPosts, function(careerPost) {
            return careerPost.career_category === category
        }.bind(category));
    },
    setCateogryFilters() {
        this.categoryFilters = _.chain(this.allCareerPosts)
            .map(careerPost => {
                return careerPost.career_category;
            })
            .uniqBy(careerCategory => {
                return careerCategory;
            })
            .value();
    },
    setLocationFilters() {
        this.locationFilters = _.chain(this.allCareerPosts)
            .map(careerPost => {
                return careerPost.career_location;
            })
            .uniqBy(careerLocation => {
                return careerLocation;
            })
            .value();
    },
    toggleFilter(type, value) {
      if (value === '' || this.disabledFilters[type].includes(value)) {
        return
      }

      if (this.activeFilters[type].includes(value)) {
        // Already on, so remove the option
        let valueIndex = this.activeFilters[type].indexOf(value)
        this.activeFilters[type].splice(valueIndex, 1)
      } else {
        this.activeFilters[type] = this.activeFilters[type].concat([value])
      }

      this.filterCareerPosts()
    },
    updateURLFilters() {
      let filters = this.activeFilters

      let newHash = Object.keys(filters)
        .map(filterName => `${filterName}=${filters[filterName].join(",")}`)
        .join("&")

      window.location.hash = newHash
    },
    applyURLFilters() {
      // Deconstructs a URL filter like:
      // #brands=kimpton,comfort-inn&regions=quebec,ontario
      let hash = window.location.hash.slice(1)

      // Bail out if there are no options
      if (hash.length === 0) return

      let pairs = hash.split("&")
      let options = pairs.map(pair => {
        let kv = pair.split("=")
        let value = kv[1].split(",")
        return { name: kv[0], values: value }
      })

      options.forEach(option => {
        option.values.forEach(value => {
          this.toggleFilter(option.name, value);
        })
      })
    },
    resetFilter(type) {
      this.activeFilters[type] = []
      this.filterCareerPosts()
    },
    filterCareerPosts() {
      let results = []

      this.allCareerPosts.forEach(careerPost => {
        let categoryMatches = true
        let locationMatches = true

        if (this.activeFilters["categories"].length > 0) {
          categoryMatches = this.activeFilters["categories"].includes(careerPost.career_category)
        }

        if (this.activeFilters["locations"].length > 0) {
          locationMatches = this.activeFilters["locations"].includes(careerPost.career_location)
        }

        if (categoryMatches && locationMatches) {
          results.push(careerPost)
        }
      })

      this.filteredCareerPosts = results,
      this.updateURLFilters()
    }
  }
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  margin: 50px auto;
  color: white;
  text-align: center;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/career-listing.vue